export function lib(vendor, file, isModule = true) {
    if (!lib.libs[vendor]) {
        return Promise.reject(new Error(`Vendor ${vendor} not found in lib.libs`));
    }

    if (lib.libs[vendor].files[file] === true) {
        return Promise.resolve();
    }

    const src = lib.getSrc(vendor, file);
    return new Promise((resolve) => {
        if (src.endsWith('.css')) {
            real.dom.appendStylesheet(src, () => {
                lib.libs[vendor].files[file] = true;
                resolve(src);
            });
        } else {
            real.dom.appendScript(src, () => {
                lib.libs[vendor].files[file] = true;
                resolve(src);
            }, isModule);
        }
    });
}

lib.setLibraries = (libs) => {
    lib.libs = {};
    for (const [vendor, version] of Object.entries(libs)) {
        lib.libs[vendor] = {
            vendor: vendor,
            version: version,
            files: {},
        };
    }
};

lib.getVersion = (vendor) => {
    return lib.libs[vendor].version || null;
};

lib.getSrc = (vendor, file) => {
    if (!lib.libs[vendor]) {
        return Promise.reject(new Error(`Vendor ${vendor} not found in lib.libs`));
    }

    if (lib.libs[vendor].files[file] === true) {
        return Promise.resolve();
    }

    const version = lib.libs[vendor].version;
    return `${real.cdnUri}/dist/vendor/${vendor}/${version}/${file}`;
};

lib.ready = (vendor, fileName) => {
    if (lib.libs[vendor]) {
        lib.libs[vendor].files[fileName] = true;
    }
};

lib.module = (vendor, file) => {
    if (!lib.libs[vendor]) {
        return Promise.reject(new Error(`Vendor ${vendor} not found in lib.libs`));
    }

    const version = lib.libs[vendor].version;
    return import(`${real.cdnUri}/dist/vendor/${vendor}/${version}/${file}`);
};

globalThis.lib = lib;
